import React, { useState, useEffect } from "react";
import { Box, Card, Avatar, CardContent, Typography, Icon } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Cookie from "js-cookie";
import HomePageLayout from "examples/LayoutContainers/HomePageLayout";
import logo from "../../assets/images/logos/kotacrop.png";
import businessForms from "../../assets/landingimages/images/Business Forms.png";
import payout from "../../assets/landingimages/images/payreceipt.png";
import account from "../../assets/landingimages/images/accounts.png";
import datadock from "../../assets/landingimages/images/datamack.png";
import employeeManagement from "../../assets/landingimages/images/employeeManagement.png";
import backgroundImage from "../../assets/landingimages/images/background4.jpg";
import image from "../../assets/landingimages/images/image.png";
import { useMaterialUIController, setUser, setMiniSidebar } from "context";
import URLs from "constants/urls";
import {
  MdSpaceDashboard,
  MdBusinessCenter,
  MdArticle,
  MdEventRepeat,
  MdAccountBalanceWallet,
  MdReceiptLong,
  MdAssessment,
  MdShowChart,
  MdPeopleAlt,
  MdCorporateFare,
  MdHome,
  MdWorkOutline,
  MdTaskAlt,
  MdAdminPanelSettings,
  MdOutlineDesk,
  MdPayment,
  MdManageAccounts,
  MdSecurity,
  MdMiscellaneousServices,
  MdOutlineApproval,
  MdOutlineHowToReg,
  MdOutlineAccountBalance,
  MdOutlineRequestQuote,
  MdAnalytics,
  MdFactCheck,
  MdOutlineSettings,
  MdPerson,
  MdPostAdd,
} from "react-icons/md";
import { RiGovernmentLine, RiFileTextLine, RiUserSettingsLine } from "react-icons/ri";
import { FiCheckSquare } from "react-icons/fi";
import { StyledSnackbar, StyledAlert } from "components/StyledComponents/styledComponents.js";
import Swal from "sweetalert2";
import { Button, Container, Grid, Fade } from "@mui/material";
import { MdArrowForward } from "react-icons/md";

const LandingDashboard = () => {
  const navigate = useNavigate();
  const [controller, dispatch] = useMaterialUIController();
  const { user } = controller;
  const [employeeId, setEmployeeId] = useState(null);

  const setAlert = (errMsg) => {
    Swal.fire({
      icon: "error",
      title: "Access Denied!",
      text: errMsg,
      confirmButtonText: "OK",
    });
  };

  const baseCardsData = [
    {
      title: "Business Forms",
      image: businessForms,
      moduleId: 1,
    },
    {
      title: "Admin",
      image: employeeManagement,
      moduleId: 2,
    },
    {
      title: "HRMS",
      image: payout,
      moduleId: 3,
    },
    {
      title: "Finance",
      image: account,
      moduleId: 4,
    },
    {
      title: "Report Center",
      image: datadock,
      moduleId: 5,
    },
  ];

  useEffect(() => {
    const storedEmployeeId = Cookie.get("employee_id");
    if (storedEmployeeId) {
      setEmployeeId(storedEmployeeId);
    }
  }, []);

  useEffect(() => {
    navigate("/landing-page", { replace: true });
  }, []);

  useEffect(() => {
    window.history.pushState(null, null, window.location.href);
    const handleBackNavigation = () => {
      if (localStorage.getItem("authToken")) {
        navigate("/landing-page", { replace: true });
      }
    };
    window.addEventListener("popstate", handleBackNavigation);
    return () => window.removeEventListener("popstate", handleBackNavigation);
  }, [navigate]);

  const transformData = (data) => {
    const result = [];
    const groupedMap = new Map();
    const moduleIcons = {
      Dashboard: <MdSpaceDashboard />,
      "Business Masters": <MdBusinessCenter />,
      "Business Forms": <MdArticle />,
      "Month End": <MdEventRepeat />,
      "Account Masters": <MdAccountBalanceWallet />,
      Vouchers: <MdReceiptLong />,
      "Business Reports": <MdAssessment />,
      Reports: <MdAssessment />,
      HRMS: <MdPeopleAlt />,
      "Head Office": <RiGovernmentLine />,
      "Home Page": <MdHome />,
      EmployeeLetterDesk: <MdWorkOutline />,
      Approvals: <FiCheckSquare />,
      Admin: <MdAdminPanelSettings />,
      "My Desk": <MdOutlineDesk />,
      "Invoice Management": <MdOutlineRequestQuote />,
      "Payment Processing": <MdPayment />,
      MIS: <MdMiscellaneousServices />,
      "Company Setup": <MdOutlineSettings />,
      Access: <MdSecurity />,
      "Provider & DSA Operations": <MdCorporateFare />,
      "Pre Joining": <MdOutlineHowToReg />,
      "Payroll Management": <MdOutlineAccountBalance />,
      Profiles: <MdPerson />,
      Invoices: <MdOutlineRequestQuote />,
      Operation: <MdTaskAlt />,
      Analytics: <MdAnalytics />,
      "Data Setup": <MdPostAdd />,
      "Post Joining": <MdOutlineHowToReg />,
      Payroll: <MdOutlineAccountBalance />,
      "Review & Approvals": <MdFactCheck />,
      "Profit and Loss Report": <MdAssessment />,
    };
    data.forEach((item) => {
      const { mainMenuId, mainMenu, subMenuId, subMenuName, routingPath, type, icon, component } =
        item;
      if (!groupedMap.has(mainMenuId)) {
        groupedMap.set(mainMenuId, {
          mainMenuId,
          mainMenu,
          children: [],
        });
      }
      groupedMap.get(mainMenuId).children.push({
        subMenuId,
        subMenuName,
        routingPath,
        type,
        menuKey: subMenuName.toLowerCase().replace(/\s+/g, "-"),
        icon,
        component,
      });
    });
    groupedMap.forEach((group) => {
      if (group.children.length === 1) {
        const child = group.children[0];
        result.push({
          type: "collapse",
          name: group.mainMenu,
          key: child.menuKey,
          route: child.routingPath,
          icon: <Icon fontSize="small">{child.icon}</Icon>,
          component: child.component,
        });
      } else {
        result.push({
          type: "dropdown",
          name: group.mainMenu,
          key: group.mainMenu.toLowerCase().replace(/\s+/g, "-"),
          icon: moduleIcons[group.mainMenu],
          collapse: [
            {
              type: "collapse",
              name: "",
              key: "",
              collapse: group.children.map((child) => ({
                type: "collapse",
                name: child.subMenuName,
                key: child.menuKey,
                route: child.routingPath,
                icon: <Icon fontSize="small">{child.icon}</Icon>,
                component: child.component,
              })),
            },
          ],
        });
      }
    });
    return result;
  };

  const handleModuleClick = async (moduleId) => {
    if (!user) {
      setAlert("Your session has expired. Please log in again.");
      navigate("/landing-page");
      Cookie.remove("access_token");
      Cookie.remove("jwt_token");
      Cookie.remove("hrms_token");
      return;
    }

    // Then check for employeeId
    if (!user.employeeId) {
      setAlert("Employee ID not found. Please log in again.");
      navigate("/landing-page");
      Cookie.remove("access_token");
      Cookie.remove("jwt_token");
      Cookie.remove("hrms_token");
      return;
    }
    try {
      const response = await fetch(
        `${URLs.userManuByModuleId}?employeeId=${user.employeeId}&moduleId=${moduleId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookie.get("jwt_token")}`,
          },
        }
      );
      if (response.status === 204) {
        setAlert("You are not authorized to access this module");
        return;
      }
      if (!response.ok) {
        throw new Error("Failed to fetch menu access details");
      }
      const menuDetails = await response.json();
      if (!menuDetails || menuDetails.length === 0) {
        setAlert("You are not authorized to access this module");
        return;
      }
      const transformedMenu = transformData(menuDetails);
      setUser(dispatch, { ...user, menu: transformedMenu });
      setMiniSidebar(dispatch, true);
      if (menuDetails[0]?.routingPath) {
        navigate(menuDetails[0].routingPath);
      } else {
        setAlert("Invalid module data. No routing path available.");
      }
    } catch (error) {
      setAlert(error.message || "Something went wrong");
    }
  };

  return (
    <HomePageLayout>
      <Box
        sx={{
          height: "100%",
          bgcolor: "#FFFFFF",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Grid container sx={{ flex: 1 }}>
          <Grid
            item
            xs={12}
            md={5}
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              bgcolor: "#F9F9F9",
            }}
          >
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <Box
                component="img"
                src={logo}
                alt="Company Logo"
                sx={{ width: { xs: "70px", md: "100px" }, mb: 2, mt: 4 }}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                width: "100%",
                backgroundColor: "#FF6600", // your dark section
                display: "flex",
                justifyContent: "center",
                borderTopLeftRadius: "20%",
                borderTopRightRadius: "20%",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  mt: 4,
                  textAlign: "center",
                }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    color: "#ffffffff",
                    fontWeight: "bold",
                    mb: 1,
                    fontSize: { xs: "1.25rem", md: "1.8rem" },
                  }}
                >
                  Welcome to Your Business Hub
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#ffffffff",
                    mb: 3,
                    fontSize: { xs: "0.85rem", md: "1rem" },
                  }}
                >
                  Streamline your operations with our powerful modules.
                </Typography>

                {/* Radial Arrow Button */}
                <Button
                  onClick={() => handleModuleClick(baseCardsData[0].moduleId)}
                  sx={{
                    width: 60,
                    height: 60,
                    borderRadius: "50%",
                    bgcolor: "#FFFFFF",
                    border: "2px solid #444444",
                    margin: "auto",
                    display: "flex", // ensure icon centers
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 4px 12px rgba(255,102,0,0.3)",
                    transition: "0.3s",
                    "&:hover": {
                      bgcolor: "#ffffff",
                      transform: "scale(1.1)",
                    },
                  }}
                >
                  <MdArrowForward size={100} />
                </Button>
              </Box>
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            md={7}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              bgcolor: "#FFFFFF",
              p: { xs: 2, md: 3 },
            }}
          >
            <Container
              maxWidth="md"
              sx={{
                flex: 1,
                display: "flex",
                flexWrap: "wrap",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#333333",
                  borderRadius: "8px", // 👈 rounded background
                  px: 3, // horizontal padding
                  py: 1, // vertical padding
                  margin: "auto",
                  mb: 2,
                  mt: 4,
                  width: "fit-content", // shrink-wrap to text
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    color: "#ffffff",
                    fontWeight: 600,
                    fontSize: { xs: "1rem", md: "1rem" },
                  }}
                >
                  Explore Our Modules
                </Typography>
              </Box>
              {/* <Grid
                container
                spacing={2}
                sx={{
                  flexWrap: "wrap",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {baseCardsData.map((item, index) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.title}>
                    <Fade
                      in
                      timeout={500 + index * 150}
                      style={{ transitionDelay: `${index * 100}ms` }}
                    >
                      <Card
                        sx={{
                          backgroundImage: "linear-gradient( #ffffff, #ffffff)",
                          backdropFilter: "blur(10px)",
                          border: "1px solid rgba(255, 255, 255, 0.2)",
                          borderRadius: "16px",
                          transition:
                            "box-shadow 0.4s ease, border-color 0.4s ease, transform 0.4s ease",
                          willChange: "box-shadow, border-color, transform",
                          "&:hover": {
                            backgroundImage: "linear-gradient(#ffffff, #ffffff)",
                            boxShadow: "0 12px 24px rgba(0, 0, 0, 0.15)",
                            borderColor: "rgba(255, 102, 0, 0.5)",
                            transform: "translateY(-4px)",
                          },
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          p: 2,
                          pt: 4, // Added padding to accommodate the title overlay
                          height: "90%",
                          overflow: "hidden",
                          position: "relative", // Added for positioning the title overlay
                        }}
                      >
                        <Box
                          sx={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            height: "40px",
                            color: "#ffffff",
                            bgcolor: "#FF6600",
                            borderTopLeftRadius: "16px",
                            borderTopRightRadius: "16px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Typography
                            variant="h6"
                            sx={{
                              color: "#ffffff",
                              fontWeight: 700,
                              fontSize: "0.9rem",
                              textAlign: "center",
                              zIndex: 1,
                            }}
                          >
                            {item.title}
                          </Typography>
                        </Box>

                        <Box
                          component="img"
                          src={item.image}
                          alt={item.title}
                          sx={{
                            width: "80px",
                            height: "80px",
                            borderRadius: "50%",
                            objectFit: "cover",
                            border: "2px solid rgba(255, 102, 0, 0.3)",
                            mb: 2,
                            mt: 2, // Added margin to account for the title overlay
                            transition: "all 0.4s ease",
                            "&:hover": {
                              transform: "rotate(8deg) scale(1.15)",
                              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
                            },
                          }}
                        />

                        <CardContent sx={{ flexGrow: 1, textAlign: "center", p: 0, width: "100%" }}>
                          <Button
                            variant="contained"
                            size="medium"
                            sx={{
                              bgcolor: "#FFFFFF",
                              color: "#FF6600",
                              border: "none",
                              fontSize: { xs: "0.8rem", sm: "0.9rem" },
                              px: 2.5,
                              py: 0.8,
                              borderRadius: "8px",
                              height: "20px",
                              textTransform: "none",
                              fontWeight: 600,
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                              margin: "auto",
                              transition: "all 0.3s ease",
                              "&:hover": {
                                bgcolor: "#FFFFFF",
                                transform: "scale(1.05)",
                                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
                              },
                              "&:hover .arrowIcon": {
                                transform: "translateX(6px)",
                              },
                            }}
                            endIcon={
                              <MdArrowForward
                                className="arrowIcon"
                                size={18}
                                style={{ transition: "transform 0.3s ease" }}
                              />
                            }
                            onClick={() => handleModuleClick(item.moduleId)}
                          >
                            Explore
                          </Button>
                        </CardContent>
                      </Card>
                    </Fade>
                  </Grid>
                ))}
              </Grid> */}
              <Grid
                container
                spacing={2}
                sx={{
                  flexWrap: "wrap",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {baseCardsData.map((item, index) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.title}>
                    <Fade
                      in
                      timeout={500 + index * 150}
                      style={{ transitionDelay: `${index * 100}ms` }}
                    >
                      <Card
                        sx={{
                          backgroundImage: "linear-gradient( #ffffff, #ffffff)",
                          backdropFilter: "blur(10px)",
                          border: "1px solid rgba(255, 255, 255, 0.2)",
                          borderRadius: "16px",
                          transition:
                            "box-shadow 0.4s ease, border-color 0.4s ease, transform 0.4s ease",
                          willChange: "box-shadow, border-color, transform",
                          "&:hover": {
                            backgroundImage: "linear-gradient(#ffffff, #ffffff)",
                            boxShadow: "0 12px 24px rgba(0, 0, 0, 0.15)",
                            borderColor: "rgba(255, 102, 0, 0.5)",
                            transform: "translateY(-4px)",
                          },
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          p: 2,
                          pt: 4, // Added padding to accommodate the title overlay
                          height: "90%",
                          overflow: "hidden",
                          position: "relative", // Added for positioning the title overlay
                        }}
                      >
                        {/* Curved title overlay */}
                        <Box
                          sx={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            height: "40px",
                            color: "#ffffff",
                            bgcolor: "#FF6600",
                            borderTopLeftRadius: "16px",
                            borderTopRightRadius: "16px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Typography
                            variant="h6"
                            sx={{
                              color: "#ffffff",
                              fontWeight: 700,
                              fontSize: "0.9rem",
                              textAlign: "center",
                              zIndex: 1,
                            }}
                          >
                            {item.title}
                          </Typography>
                        </Box>

                        {/* Image with hover effect controlled by card hover */}
                        <Box
                          component="img"
                          src={item.image}
                          alt={item.title}
                          sx={{
                            width: "80px",
                            height: "80px",
                            borderRadius: "50%",
                            objectFit: "cover",
                            border: "2px solid rgba(255, 102, 0, 0.3)",
                            mb: 2,
                            mt: 2,
                            transition: "all 0.4s ease",
                            ".MuiCard-root:hover &": {
                              // This targets the image when card is hovered
                              transform: "rotate(8deg) scale(1.15)",
                              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
                            },
                          }}
                        />

                        {/* Content */}
                        <CardContent sx={{ flexGrow: 1, textAlign: "center", p: 0, width: "100%" }}>
                          {/* Explore Button */}
                          <Button
                            variant="contained"
                            size="medium"
                            sx={{
                              bgcolor: "#FFFFFF",
                              color: "#FF6600",
                              border: "none",
                              fontSize: { xs: "0.8rem", sm: "0.9rem" },
                              px: 2.5,
                              py: 0.8,
                              borderRadius: "8px",
                              height: "20px",
                              textTransform: "none",
                              fontWeight: 600,
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                              margin: "auto",
                              transition: "all 0.3s ease",
                              "&:hover": {
                                bgcolor: "#FFFFFF",
                                transform: "scale(1.05)",
                                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
                              },
                              "&:hover .arrowIcon": {
                                transform: "translateX(6px)",
                              },
                            }}
                            endIcon={
                              <MdArrowForward
                                className="arrowIcon"
                                size={18}
                                style={{ transition: "transform 0.3s ease" }}
                              />
                            }
                            onClick={() => handleModuleClick(item.moduleId)}
                          >
                            Explore
                          </Button>
                        </CardContent>
                      </Card>
                    </Fade>
                  </Grid>
                ))}
              </Grid>
            </Container>
          </Grid>
        </Grid>

        <Box
          sx={{
            bgcolor: "#333333",
            py: 1.5,
            textAlign: "center",
            borderTop: "2px solid #FF6600",
          }}
        >
          <Container maxWidth="lg">
            <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap">
              <Typography sx={{ color: "#FFFFFF", fontSize: "0.7rem" }}>
                Designed by{" "}
                <a
                  href="https://www.sconexsoft.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#FF6600", textDecoration: "none" }}
                >
                  Sconexsoft
                </a>
              </Typography>
              <Box
                component="img"
                src={image}
                alt="Brand Logo"
                sx={{
                  height: { xs: "24px", md: "32px" },
                  maxWidth: "140px",
                  borderRadius: "7px",
                  pl: 1,
                  pr: 1,
                  objectFit: "contain",
                  backgroundColor: "#ffffff",
                  border: "1px solid #FFFFFF",
                }}
              />
            </Box>
          </Container>
        </Box>
      </Box>
    </HomePageLayout>
  );
};

export default LandingDashboard;
